// extracted by mini-css-extract-plugin
export default {"catImage":"Cat_catImage__n8M-H","catItem":"Cat_catItem__p0TfU","backBtn":"Cat_backBtn__pNjmj","catInfo":"Cat_catInfo__0XAR1"};